<template>
  <div>
    <vs-card>
      <!-- <h4 class="card-title d-flex">
        <span>Spécifiques</span>
      </h4> -->
      <div class="card-body">
        <vs-row vs-w="12">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="3"
            vs-sm="6"
            vs-xs="12"
          >
            <router-link to="/statistics/ebu/service-period">
              <vs-card actionable class="cardx" fixedHeight>
                <div slot="header">
                  <h4>Par service et par période</h4>
                </div>
              </vs-card>
            </router-link>
          </vs-col>
          <!-- <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="3"
            vs-sm="6"
            vs-xs="12"
          >
            <router-link to="/statistics/specifics/total-request">
              <vs-card actionable class="cardx" fixedHeight>
                <div slot="header">
                  <h4>Total requêtes</h4>
                </div>
              </vs-card>
            </router-link>
          </vs-col> -->
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="3"
            vs-sm="6"
            vs-xs="12"
          >
            <router-link to="/statistics/ebu/history">
              <vs-card actionable class="cardx" fixedHeight>
                <div slot="header">
                  <h4>Top 10 des clients par période</h4>
                </div>
              </vs-card>
            </router-link>
          </vs-col>
          <!-- <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="3"
            vs-sm="6"
            vs-xs="12"
          >
            <router-link to="/statistics/specifics/history-by-group">
              <vs-card actionable class="cardx" fixedHeight>
                <div slot="header">
                  <h4>Plainte reçue par mail et par CCMT par période</h4>
                </div>
              </vs-card>
            </router-link>
          </vs-col> -->
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="3"
            vs-sm="6"
            vs-xs="12"
          >
            <router-link to="/statistics/ebu/call-reason-period">
              <vs-card actionable class="cardx" fixedHeight>
                <div slot="header">
                  <h4>Types et sous-types par période</h4>
                </div>
              </vs-card>
            </router-link>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="3"
            vs-sm="6"
            vs-xs="12"
          >
            <router-link to="/statistics/specifics/sla-category-period">
              <vs-card actionable class="cardx" fixedHeight>
                <div slot="header">
                  <h4>SLA par type de demande et par période</h4>
                </div>
              </vs-card>
            </router-link>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="3"
            vs-sm="6"
            vs-xs="12"
          >
            <router-link to="/statistics/specifics/request-canal">
              <vs-card actionable class="cardx" fixedHeight>
                <div slot="header">
                  <h4>Par canal</h4>
                </div>
              </vs-card>
            </router-link>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="3"
            vs-sm="6"
            vs-xs="12"
          >
            <router-link to="/statistics/specifics/agent-with-realtime">
              <vs-card actionable class="cardx" fixedHeight>
                <div slot="header">
                  <h4>Agents par période</h4>
                </div>
              </vs-card>
            </router-link>
          </vs-col>
        </vs-row>
      </div>
    </vs-card>
  </div>
</template>

<script>
export default {
  name: "ebu",
};
</script>

<style scoped>
h4 {
  height: 60px;
}
.con-vs-card.fixedHeight {
  width: 210px;
}
</style>
